"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAYMENT_LINK_STATUS = exports.CONEKTA_CARD_TYPES = exports.PAYMENT_GATEWAY_ENVIRONMENT = exports.PAYMENT_STATUS = exports.CARD_BRANDS = exports.PAYMENT_TYPES = exports.PAYMENT_METHODS = exports.PAYMENT_GATEWAYS = void 0;
var PAYMENT_GATEWAYS;
(function (PAYMENT_GATEWAYS) {
    PAYMENT_GATEWAYS[PAYMENT_GATEWAYS["CONEKTA"] = 1] = "CONEKTA";
})(PAYMENT_GATEWAYS = exports.PAYMENT_GATEWAYS || (exports.PAYMENT_GATEWAYS = {}));
;
var PAYMENT_METHODS;
(function (PAYMENT_METHODS) {
    PAYMENT_METHODS[PAYMENT_METHODS["CARD"] = 1] = "CARD";
    PAYMENT_METHODS[PAYMENT_METHODS["SPEI"] = 2] = "SPEI";
    PAYMENT_METHODS[PAYMENT_METHODS["CASH"] = 3] = "CASH";
    PAYMENT_METHODS[PAYMENT_METHODS["FREE"] = 4] = "FREE";
})(PAYMENT_METHODS = exports.PAYMENT_METHODS || (exports.PAYMENT_METHODS = {}));
;
var PAYMENT_TYPES;
(function (PAYMENT_TYPES) {
    PAYMENT_TYPES[PAYMENT_TYPES["GLOBAL"] = 1] = "GLOBAL";
    PAYMENT_TYPES[PAYMENT_TYPES["USER"] = 2] = "USER";
})(PAYMENT_TYPES = exports.PAYMENT_TYPES || (exports.PAYMENT_TYPES = {}));
var CARD_BRANDS;
(function (CARD_BRANDS) {
    CARD_BRANDS["VISA"] = "visa";
    CARD_BRANDS["MASTERCARD"] = "mastercard";
    CARD_BRANDS["AMERICAN_EXPRESS"] = "american_express";
})(CARD_BRANDS = exports.CARD_BRANDS || (exports.CARD_BRANDS = {}));
var PAYMENT_STATUS;
(function (PAYMENT_STATUS) {
    PAYMENT_STATUS[PAYMENT_STATUS["PENDIENTE_PAGO"] = 1] = "PENDIENTE_PAGO";
    PAYMENT_STATUS[PAYMENT_STATUS["REFERENCIA_GENERADA"] = 2] = "REFERENCIA_GENERADA";
    PAYMENT_STATUS[PAYMENT_STATUS["EN_PROCESO"] = 3] = "EN_PROCESO";
    PAYMENT_STATUS[PAYMENT_STATUS["PAGO_EXITOSO"] = 4] = "PAGO_EXITOSO";
    PAYMENT_STATUS[PAYMENT_STATUS["PAGO_FALLIDO"] = 5] = "PAGO_FALLIDO";
    PAYMENT_STATUS[PAYMENT_STATUS["PAGO_CANCELADO"] = 6] = "PAGO_CANCELADO";
    PAYMENT_STATUS[PAYMENT_STATUS["REEMBOLSADO"] = 7] = "REEMBOLSADO";
})(PAYMENT_STATUS = exports.PAYMENT_STATUS || (exports.PAYMENT_STATUS = {}));
var PAYMENT_GATEWAY_ENVIRONMENT;
(function (PAYMENT_GATEWAY_ENVIRONMENT) {
    PAYMENT_GATEWAY_ENVIRONMENT["SANDBOX"] = "sandbox";
    PAYMENT_GATEWAY_ENVIRONMENT["PROD"] = "production";
})(PAYMENT_GATEWAY_ENVIRONMENT = exports.PAYMENT_GATEWAY_ENVIRONMENT || (exports.PAYMENT_GATEWAY_ENVIRONMENT = {}));
/*** Conekta enums */
var CONEKTA_CARD_TYPES;
(function (CONEKTA_CARD_TYPES) {
    CONEKTA_CARD_TYPES["CREDIT"] = "credit";
    CONEKTA_CARD_TYPES["DEBIT"] = "debit";
})(CONEKTA_CARD_TYPES = exports.CONEKTA_CARD_TYPES || (exports.CONEKTA_CARD_TYPES = {}));
;
var PAYMENT_LINK_STATUS;
(function (PAYMENT_LINK_STATUS) {
    PAYMENT_LINK_STATUS[PAYMENT_LINK_STATUS["PENDING"] = 1] = "PENDING";
    PAYMENT_LINK_STATUS[PAYMENT_LINK_STATUS["COMPLETED"] = 2] = "COMPLETED";
    PAYMENT_LINK_STATUS[PAYMENT_LINK_STATUS["EXPIRED"] = 3] = "EXPIRED";
    PAYMENT_LINK_STATUS[PAYMENT_LINK_STATUS["CANCELED"] = 4] = "CANCELED";
})(PAYMENT_LINK_STATUS = exports.PAYMENT_LINK_STATUS || (exports.PAYMENT_LINK_STATUS = {}));
;
